import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  subtitle: {
    fontSize: 12,
  },
  companyLogo: {
    marginRight: 20,
    width: 50,
    height: 50,
    background: '#f2eded',
  },
}));
